export class DamagedUtility {
    id!: string
    indexId!: number

    /** Date the utility was damaged. */
    damageDate?: Date | string
    /** Vista job number (e.g. `12345.`); display as `id name`. */
    job!: string
    location!: string
    descriptionOfDamage!: string

    blueStakeNumber!: string
    blueStakeValidDate?: Date | string
    typeOfUtility!: string
    utilityOwner!: string
    whoMarkedTheUtility!: string
    whoRepairedTheUtility!: string

    /** WebApps user GUIDs. */
    damagedByUserId?: string | null
    foremanUserId?: string | null
    superintendentUserId?: string | null

    /** Notifications, stored as `Yes` | `No` | `N/A`. */
    pmNotified?: string | null
    peNotified?: string | null
    safetyDepartmentNotified?: string | null
    fireAndEmsNotified?: string | null

    /** Assessment answers, stored as `Yes` | `No` | `N/A`. */
    damagedBeforeExcavation?: string | null
    damagedBeforeExcavationComments!: string
    vanConAtFault?: string | null
    vanConAtFaultComments!: string
    withinTwoFootTolerance?: string | null
    withinTwoFootToleranceComments!: string
    markedCorrectly?: string | null
    markedCorrectlyComments!: string
    prePhotosTaken?: string | null

    /** Simplified signature: who signed off and when. */
    signedByUserId?: string | null
    signedDate?: Date | string

    createdOn?: Date | string
    createdByUserId?: string | null
    archived!: boolean

    imageUrls: string[] = []
    /** Parallel to imageUrls; original upload names from the server. */
    imageFileNames: string[] = []
}
